<template>
    
    <p class="text-h6 text-center">{{ `Ausências para ${monthsList[currentMonth]}, ${currentYear}.` }}</p>
    <v-row
        :class="[
            'ma-0',
            'mt-8',
            'rounded-lg',
            // 'rounded-ts-lg',
            // 'rounded-te-lg',
            'd-flex',
            'flex-row',
            'justify-space-between',
            'align-stretch',
            'bg-primary',
            'pt-2',
            'ga-4',
        ]"
    >   
        <v-col cols="12" md="3" 
            :class="[
                'align-content-center' ,
                'flex-1-1-0',
                /* mdAndDown ? 'order-3' : '' */
            ]"
        >
            <v-btn
                prepend-icon="mdi-chevron-left"
                :class="[
                    'text-none',
                    'px-0',
                    mdAndDown ? 'w-100' : '',
                ]"
                :variant="mdAndDown ? 'outlined' : 'text'"
                @click="goToPreviousMonth"
            >
                {{ monthsList[(currentMonth + 11) % 12] }}
            </v-btn>
        </v-col>
        <v-col cols="12" md="3"  
        :class="[
                'align-content-center' ,
                /* mdAndDown ? 'order-1' : '' */
            ]"
        >
            <v-select
                    v-model="currentYear"
                    :items="yearsList"
                    variant="underlined"
                    label="Ano"
                    :disabled="fetchingAbsencesList"
                    hide-details
                />
        </v-col>
        <v-col cols="12" md="3"  
            :class="[
                'align-content-center' ,
                /* mdAndDown ? 'order-2' : '' */
            ]">
            <v-select
                    v-model="currentMonth"
                    :items="monthsList.map((title, value) => ({ title, value }))"
                    variant="underlined"
                    label="Mês"
                    :disabled="fetchingAbsencesList"
                    hide-details
                />
        </v-col>
        <v-col cols="12" md="3"  
            :class="[
                'align-content-center' ,
                'flex-1-1-0',
                /* mdAndDown ? 'order-5' : '' */
            ]"
        >
            <v-btn
                append-icon="mdi-chevron-right"
                :class="[
                    'text-none',
                    'px-0',
                    'w-100',
                    'justify-end'
                ]"
                :variant="mdAndDown ? 'outlined' : 'text'"
                @click="goToNextMonth"
            >
                {{ monthsList[(currentMonth + 1) % 12] }}
            </v-btn>
        </v-col>        
        <v-col cols="12" class="pa-0 " style="min-height: 360px;"
            :class="[
                /* mdAndDown ? 'order-4' : '' */
            ]"           
            >
            <v-progress-linear 
                class=""
                indeterminate 
                :style="{
                    opacity: fetchingAbsencesList ? 1 : 0,
                    transition: 'opacity ease-in-out 1s'
    
                }"
            ></v-progress-linear>
            <v-calendar
                v-model="calendarDate"
                ref="calendar"
                event-overlap-mode="column"
                :event-overlap-threshold="30"
                :events="absencesList"
                :event-color="resolveAbsenceColor"
                :type="styles.type"
                :weekdays="weekdaysList"
                event-start="start_date"
                event-end="end_date"
                @change="fetchAbsences"
                class="rounded-be-lg rounded-bs-lg"
            >
                <template #event="{event}">
                    <span class="d-flex ga-4 align-baseline">
                        <v-icon>mdi-beach</v-icon>
                        <span>
                            {{ resolvedAbsenceTooltip(event) }}
                        </span>
                    </span>
                </template>
            </v-calendar>
        </v-col>
    </v-row>
    
    <v-row class="ma-0">
    </v-row>
</template>
<script setup>
import { computed, onMounted, ref, watch } from 'vue';
import { useSessionStore } from '@/stores/SessionStore'
import Department from '@/api/departments/Department';
import AbsenceRequest from '../../../api/absences/requests/AbsenceRequests';
import { getDate } from '../../../composables/datetime';
import {useDisplay} from "vuetify";

const props = defineProps({
    department_ids: {
        type: Array,
        default: null,
    }
});

const weekdaysReference = {
    "mon-fri": [1, 2, 3, 4, 5],
    "sun-sat": [0, 1, 2, 3, 4, 5, 6],
};
const monthsList = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro"
]

const sessionStore = useSessionStore();
const {mdAndDown} = useDisplay();

const today = new Date();
const currentYear = ref(today.getFullYear());
const currentMonth = ref(today.getMonth());
const yearsList = Array.from(Array(currentYear.value + 2).keys()).toReversed().toSpliced(currentYear.value - 2000);
const calendarDate = computed({
    get() {
        return new Date(currentYear.value, currentMonth.value, 1);
    },
    set(value) {
        const date = new Date(value);

        if (Number.isNaN(date.getTime())) {
            return;
        }

        currentYear.value = date.getFullYear();
        currentMonth.value = date.getMonth();
    },
});
const userDepartment = ref(sessionStore?.user?.departments?.find((d) => d?.id == sessionStore?.user?.paid_by_department_id))
const filters = ref({
//     department_ids: props?.department_ids
//                     ?? sessionStore?.user?.departments
//                     ?? [userDepartment.value]
//                     ,
    department_ids: [userDepartment.value],
    user_ids: [sessionStore?.user?.id],
    start_date: getDate(new Date(currentYear.value, currentMonth.value, 1)),
    end_date: getDate(new Date(currentYear.value, currentMonth.value + 1, 0)),
    page: 1,
    last_page: null,
});

const styles = ref({
    type: "month",
    weekdays: "mon-sun",
});

const absencesList = ref([]);
const fetchingAbsencesList = ref(false);
const weekdaysList = computed(() => weekdaysReference[styles.value.weekdays]);
const departmentsList = ref([]);
const fetchingDepartments = ref(false);
const paginationResultKeysToSkip = [
    "current_page",
    "data",
    "links",
    "first_page_url",
    "last_page_url",
    "next_page_url",
    "prev_page_url",
]

watch([currentYear, currentMonth], () => {
    filters.value = {
        ...filters.value,
        start_date: getDate(new Date(currentYear.value, currentMonth.value, 1)),
        end_date: getDate(new Date(currentYear.value, currentMonth.value + 1, 0)),
        page: 1,
        last_page: null,
    };
    absencesList.value = [];
});

function goToPreviousMonth() {
    if (currentMonth.value === 0) {
        currentMonth.value = monthsList.length - 1;
        currentYear.value -= 1;
        return;
    }

    currentMonth.value -= 1;
}

function goToNextMonth() {
    if (currentMonth.value === monthsList.length - 1) {
        currentMonth.value = 0;
        currentYear.value += 1;
        return;
    }

    currentMonth.value += 1;
}

async function fetchDepartments() {
    if(fetchingDepartments.value) {
        return;
    }

    try {
        fetchingDepartments.value = true;
        
        const departmentsResponse = await Department.all({scope_to_user: 0});

        departmentsList.value = departmentsResponse?.data ?? [];

    } catch (error) {
        console.error(
            "Erro a obter lista de Centros de Custo",
            error,
        );
    } finally {
        fetchingDepartments.value = false;
    }
}

async function fetchAbsences() {
    if(fetchingAbsencesList.value) {
        return;
    }

    try {
        fetchingAbsencesList.value = true;
        do {
            const payload = {
                ...filters.value,
                department_ids: filters.value.department_ids.map((d) => d.id),
            }
            const newAbsences = await AbsenceRequest.all(payload);

            absencesList.value = [
                ...absencesList.value,
                ...newAbsences?.data?.data
            ];

            filters.value = {
                ...filters.value,
                ...Object.fromEntries(
                    Object.entries(newAbsences?.data).filter(([key]) => !paginationResultKeysToSkip.includes(key))
                )
            };

        } while (filters.value.page < filters.value.last_page);
        
    } catch (error) {
        
    } finally {
        fetchingAbsencesList.value = false;
    }
}

function resolveAbsenceColor(event) {
    if(event?.processed_at !== null) {
        return "bg-success";
    }

    if(event?.approved_at !== null) {
        return "bg-info";
    }

    return "bg-warning";
}

function resolvedAbsenceTooltip(event) {
    let employeeLabel = "";
    let absencePeriodLabel = "";
    let absenceType = "";

    if(event?.user) {
        employeeLabel += `${event?.user?.worker_code ? event?.user?.worker_code : 'Sem código'}`
        employeeLabel += " - ";
        employeeLabel +=  `${event?.user?.name ? event?.user?.name : 'Sem nome'}: `
    }
    else {
        employeeLabel += `Colaborador(a): ${event?.user_id}`;
    }

    absencePeriodLabel = `${event?.start_date ?? '??'} - ${event?.end_date ?? '-'}`

    return employeeLabel + absencePeriodLabel;
}

onMounted(() => {
    // fetchDepartments();
    fetchAbsences();
})

</script>
<style scoped>

</style>
